<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-12">
        <spinner [id]="'editexcel'" [show]='activeSpinner'></spinner>
      </div>

      <div class="col-12 col-xl col-md-6">
        <div class="form-group  ">
          <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="editweightfilter['ay']" class="form-control custom-selectbox">
            <option *ngFor="let year of assesmentlist" value="{{year}}">{{year}}</option>
          </select>
          <!-- <span style="color:red" [hidden]="validation['ay']">Please Select Assessment Year </span> -->
        </div>
      </div>
      <div class="col-12 col-xl col-md-6">
        <div class="form-group ">
          <label>{{'header.monthsmapping' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="editweightfilter['month']" class="form-control custom-selectbox">
            <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
            <option *ngFor="let month of monthsList" [value]="month.key">
              {{'monthmaps.' + month['value'] | translate}}</option>
          </select>
          <!-- <span style="color:red" [hidden]="validation['month']">Please Select Assessment Year </span> -->
        </div>
      </div>
      <div class="col-12 col-xl col-md-6">
        <div class="form-group ">
          <label>{{'header.state' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]=" selectedstate" class="form-control custom-selectbox" disabled> <!-- (change)="showdistrictdropdown(selectedstate)" -->
            <option value="undefined">{{'tabledataforstates.all' | translate}}</option>
            <!-- <option *ngFor="let state of statelists" value="{{state.uuid}}">
              {{'tabledataforstates.'+ state['name'] | translate}}</option> -->
          </select>
          <!-- <span style="color:red" [hidden]="validation['state']">{{'viewreprt.validation' | translate}}</span> -->
        </div>
      </div>

      <div class="col-12 col-xl col-md-6" *ngIf="showdistdrop">
        <div class="form-group ">
          <label>{{'header.district' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="selecteddistrict" placeholder="select" class="form-control custom-selectbox">
            <option value="undefined">{{'tabledataforstates.selectstate' | translate}}</option>
            <option *ngFor="let district of distrctentityList" value="{{district['uuid']}}">
              {{ 'districtsdata.' + district['name'] | translate}}</option>
          </select>
          <span style="color:red" [hidden]="validation['district']">{{'viewreprt.validation1' | translate}}</span>
        </div>
      </div>

      <div class="col d-flex justify-content-start align-items-end">
        <div class="form-group mx-2">
          <!-- <label class="w-100">&nbsp;&nbsp;</label> -->
          <button class="btn btn-info pointer " style="margin-top: 11px;" (click)="fetchWeightData()"
            type="submit">{{'submitdata.edit' | translate }}</button>
        </div>
      </div>

    </div>
    <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm" *ngIf="showtabledata">
      <cdk-virtual-scroll-viewport #scrollViewport itemSize="50"
        [style.height]="fetchweights.length > 0 ? '500px' : '185px'">
        <table class="table text-center table-sm mt-1">
          <thead class="thead-light">
            <tr>
              <th>{{'dataSubs.sno' | translate}}</th>
              <th>{{'dataSubs.Indicator' | translate}}</th>
              <th>{{'dataSubs.weightage' | translate}}</th>
            </tr>
          </thead>
          <tbody class="text-white">
            <ng-container *ngFor="let weightdata of fetchweights;let i = index">
              <tr
                *ngIf="weightdata['label']!=null && weightdata['label']!='asdf' && weightdata['label']!='kbewkhjfojehrf' && weightdata['label']!='jtutiy' && weightdata['label']!='ygyigiyg' && weightdata['label']!='Meeting at DGC '">
                <td>{{weightdata['sno']}}</td>
                <td style="text-align: center">{{'themedataObj.' +weightdata['label'] | translate}}</td>
                <td style="width: 15%;">
                  <span> {{'dataSubs.Total' | translate}}: <input disabled="" [(ngModel)]="weightdata['weight']"
                      style="width: 61%;" class="input-style" (ngModelChange)="valuemodified(weightdata)"
                      appFloatwithMinmax></span>
                </td>
              </tr>
              <ng-container *ngFor="let data of weightdata['childList']">
                <tr *ngIf="data['label']!= 'Date Of The Meeting'">
                  <td>{{data['sno']}}</td>
                  <td style="text-align: left">{{'IndiAndSubindList.' +data['label'] | translate}}</td>
                  <td style="width: 15%;">
                    <span><input disabled="" [(ngModel)]="data['weight']" style="width: 61%;" class="input-style"
                        (ngModelChange)="valuemodified(data)" appFloatwithMinmax></span>
                  </td>
                </tr>
                <ng-container *ngFor="let item of data['childList']">
                  <tr>
                    <td>{{item['sno']}}</td>
                    <td style="text-align: left">{{'IndiAndSubindList.' +item['label'] | translate}}</td>
                    <td style="width: 15%;">
                      <span><input [(ngModel)]="item['weight']" style="width: 61%;" class="input-style"
                          (ngModelChange)="modifyparentData(data)" appFloatwithMinmax></span>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
      <div class="row" *ngIf="fetchweights.length == 0">
        <div class="col-12 nodata">
          {{ 'infotab.nodata' | translate }}
        </div>
      </div>
    </div>
    <div class="text-center" *ngIf="fetchweights.length>0" style="margin-top: 20px;">

      <!-- <button *ngIf="!approvalbutton && !userdetails['isReadOnly']" class="btn btn-info btm-sm mr-3"
        (click)="submitweights()" type="submit">Submit for Approval</button> -->
      <button class="btn btn-info mr-3" (click)="submitweights()"
        type="submit">{{'header.submit' | translate }}</button>
      <button *ngIf="!userdetails['isReadOnly']" class="btn btn-info pointer" (click)="reset()"
        type="submit">{{'submitdata.reset' | translate}}</button>
    </div>
  </div>
</div>
